<template>
  <AccordionRoot
    :id="groupId"
    :type="exclusive ? 'single' : 'multiple'"
    :collapsible="true"
    class="accordion"
    :class="accordionClass"
  >
    <slot />
  </AccordionRoot>
</template>

<script setup lang="ts">
import { useId } from 'vue'
import { AccordionRoot } from 'reka-ui'

// Accordion group powered by Reka UI's <AccordionRoot> primitive. Bootstrap
// CSS classes (.accordion, .accordion-item, .accordion-button, …) provide the
// visual styling; Reka owns state + keyboard a11y + exclusive-mode logic.
// `exclusive` maps to Reka's `type="single"`.

const groupId = `accordion-group-${useId()}`

withDefaults(
  defineProps<{
    exclusive?: boolean
    accordionClass?: string
  }>(),
  { exclusive: false, accordionClass: '' },
)
</script>
